import { combineReducers } from 'redux'

import * as R from 'ramda'

import { reducer as dbReducer } from 'src/store/db'
import { reducer as commentsReducer } from 'src/store/comments'
import { reducer as feedReducer } from 'src/store/feed'
import { reducer as errorReducer } from 'src/store/errors'
import { reducer as snackbarReducer } from 'src/store/snackbar'
import { reducer as routerReducer } from 'src/store/router'

import { reducer as boardReducer } from './board'
import { reducer as boardsReducer } from './boards'
import { reducer as collectionReducer } from './collection'
import { reducer as groupReducer } from './group'
import { reducer as userReducer } from './user'
import { reducer as modalReducer } from './modal'
import { reducer as networkReducer } from './network'
import { reducer as bannerReducer } from './banner'
import { reducer as profileReducer } from './profile'
import { reducer as dataTableReducer } from './dataTable'
import { reducer as emojiReducer } from './emoji'
import { reducer as conversationsReducer } from './conversations'
import { reducer as adminReducer } from './admin'
import { reducer as globalReducer } from './global'
import { reducer as ltiReducer } from './lti'

import { initialState as boardInitialState } from '../action-methods/board'
import { initialState as boardsInitialState } from '../action-methods/boards'
import { initialState as collectionInitialState } from '../action-methods/collection'
import { initialState as groupInitialState } from '../action-methods/group'
import { initialState as userInitialState } from '../action-methods/user'
import { initialState as modalInitialState } from '../action-methods/modal'
import { initialState as networknitialState } from '../action-methods/network'
import { initialState as bannerInitialState } from '../action-methods/banner'
import { initialState as profileInitialState } from '../action-methods/profile'
import { initialState as dataTableInitialState } from '../action-methods/dataTable'
import { initialState as emojiInitialState } from '../action-methods/emoji'
import { initialState as conversationsInitialState } from '../action-methods/conversations'
import { initialState as adminInitialState } from '../action-methods/admin'
import { initialState as globalInitialState } from '../action-methods/global'
import { initialState as ltiInitialState } from '../action-methods/lti'
// Root Reducer ==================
const createReducer =
  (reducer, initialState) =>
  (state = initialState, action) => {
    return reducer[action.type]
      ? {
          ...state,
          ...reducer[action.type]({ state, action })
        }
      : state
  }

const reducers = {}

// Ducks pattern

reducers.db = dbReducer
reducers.comments = commentsReducer
reducers.feed = feedReducer
reducers.snackbar = snackbarReducer
reducers.router = routerReducer
reducers.errors = errorReducer

// Pre-Ducks pattern

reducers.board = createReducer(boardReducer, boardInitialState)

reducers.boards = createReducer(boardsReducer, boardsInitialState)

reducers.collection = createReducer(collectionReducer, collectionInitialState)

reducers.group = createReducer(groupReducer, groupInitialState)

reducers.user = createReducer(userReducer, userInitialState)

reducers.modal = createReducer(modalReducer, modalInitialState)

reducers.network = createReducer(networkReducer, networknitialState)

reducers.banner = createReducer(bannerReducer, bannerInitialState)

reducers.profile = createReducer(profileReducer, profileInitialState)

reducers.dataTable = createReducer(dataTableReducer, dataTableInitialState)

reducers.emoji = createReducer(emojiReducer, emojiInitialState)

reducers.conversations = createReducer(
  conversationsReducer,
  conversationsInitialState
)

reducers.admin = createReducer(adminReducer, adminInitialState)

reducers.global = createReducer(globalReducer, globalInitialState)

reducers.lti = createReducer(ltiReducer, ltiInitialState)

function wrapReducer(wrapped) {
  return (state, action) => {
    if ('REPLACE_STATE' === action.type) {
      action.data.modal = modalInitialState
      return R.mergeDeepRight(state, action.data)
    }
    if ('UPDATE_IN' === action.type) {
      const path = R.lensPath(action.path)
      return R.over(path, action.fn, state)
    }
    return wrapped(state, action)
  }
}

export default wrapReducer(combineReducers(reducers))
